import React, { useState } from "react";
import BoradingCalendarMain from "./BoradingCalendarMain";

const BoardingCalendar = ({ pendingService, setPendingService, addToCart }) => {
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Format date
  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-GB") : "";

  // Calculate days difference
  const calculateDays = () => {
    if (!selectedStartDate || !selectedEndDate) return 0;
    const diff =
      new Date(selectedEndDate).getTime() -
      new Date(selectedStartDate).getTime();
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  return (
    <div className="mx-auto max-w-7xl ">
      <div className="border border-[#FD590133] py-3 px-4 sm:px-7 my-2 rounded-lg">
        <div className="flex flex-row justify-between items-center cursor-pointer">
          <p className="text-[#000048] text-xl mt-8 sm:text-2xl lg:text-[24px] font-semibold">
            Book Calendar
          </p>
        </div>

        <div className="mt-2">
          <BoradingCalendarMain
            pendingService={pendingService}
            setPendingService={setPendingService}
            isOpen={isModalOpen} 
            setIsModalOpen={setIsModalOpen} // ⭐️ Pass this so it can open the modal
            closeModal={() => setIsModalOpen(false)}
            addToCart={addToCart}
            selectedStartDate={selectedStartDate}
            setSelectedStartDate={setSelectedStartDate}
            selectedEndDate={selectedEndDate}
            setSelectedEndDate={setSelectedEndDate}
            formatDate={formatDate}
            calculateDays={calculateDays}
          />
        </div>
      </div>
    </div>
  );
};

export default BoardingCalendar;
